module.exports = __webpack_public_path__ + "img/Steve Livingston.2257e7ad.jpg";